const GRAZE_FEEDS_DID = 'did:plc:i6y3jdklpvkjvynvsrnqfdoq'

export const RACES_NATL_FEED_URI = `at://${GRAZE_FEEDS_DID}/app.bsky.feed.generator/races-natl`
export const ELECTION_DESK_FEED_URI = `at://${GRAZE_FEEDS_DID}/app.bsky.feed.generator/desk-natl`

export function stateFeedUri(state: string) {
  return `at://${GRAZE_FEEDS_DID}/app.bsky.feed.generator/races-${state.replace('US-', '').toLowerCase()}`
}

export const US_STATES: [code: string, name: string][] = [
  ['US-AL', 'Alabama'],
  ['US-AK', 'Alaska'],
  ['US-AZ', 'Arizona'],
  ['US-AR', 'Arkansas'],
  ['US-CA', 'California'],
  ['US-CO', 'Colorado'],
  ['US-CT', 'Connecticut'],
  ['US-DE', 'Delaware'],
  ['US-DC', 'District of Columbia'],
  ['US-FL', 'Florida'],
  ['US-GA', 'Georgia'],
  ['US-HI', 'Hawaii'],
  ['US-ID', 'Idaho'],
  ['US-IL', 'Illinois'],
  ['US-IN', 'Indiana'],
  ['US-IA', 'Iowa'],
  ['US-KS', 'Kansas'],
  ['US-KY', 'Kentucky'],
  ['US-LA', 'Louisiana'],
  ['US-ME', 'Maine'],
  ['US-MD', 'Maryland'],
  ['US-MA', 'Massachusetts'],
  ['US-MI', 'Michigan'],
  ['US-MN', 'Minnesota'],
  ['US-MS', 'Mississippi'],
  ['US-MO', 'Missouri'],
  ['US-MT', 'Montana'],
  ['US-NE', 'Nebraska'],
  ['US-NV', 'Nevada'],
  ['US-NH', 'New Hampshire'],
  ['US-NJ', 'New Jersey'],
  ['US-NM', 'New Mexico'],
  ['US-NY', 'New York'],
  ['US-NC', 'North Carolina'],
  ['US-ND', 'North Dakota'],
  ['US-OH', 'Ohio'],
  ['US-OK', 'Oklahoma'],
  ['US-OR', 'Oregon'],
  ['US-PA', 'Pennsylvania'],
  ['US-RI', 'Rhode Island'],
  ['US-SC', 'South Carolina'],
  ['US-SD', 'South Dakota'],
  ['US-TN', 'Tennessee'],
  ['US-TX', 'Texas'],
  ['US-UT', 'Utah'],
  ['US-VT', 'Vermont'],
  ['US-VA', 'Virginia'],
  ['US-WA', 'Washington'],
  ['US-WV', 'West Virginia'],
  ['US-WI', 'Wisconsin'],
  ['US-WY', 'Wyoming'],
]

export const ALL_MIDTERMS_FEED_URIS = [
  RACES_NATL_FEED_URI,
  ...US_STATES.map(([code]) => stateFeedUri(code)),
  ELECTION_DESK_FEED_URI,
]
